import isRunningOnClient from '@creuna/utils/is-running-on-client';
import moment from 'moment-timezone';

if (isRunningOnClient) {
  moment.tz.setDefault('Europe/Oslo');
  //console.log(moment.tz.names());
}
